import { useState } from "react";

import { Button } from "@/components/ui/button";

import { SessionHistoryDrawer } from "./SessionHistoryDrawer";

interface MySessionsButtonProps {
  scenarioId: string;
  roleplaySlug?: string;
}

export function MySessionsButton({
  scenarioId,
  roleplaySlug,
}: MySessionsButtonProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <Button
        intent="secondary"
        className="h-10"
        onClick={() => setIsDrawerOpen(true)}
      >
        My Sessions
      </Button>

      <SessionHistoryDrawer
        scenarioId={scenarioId}
        open={isDrawerOpen}
        onOpenChange={setIsDrawerOpen}
        roleplaySlug={roleplaySlug}
      />
    </>
  );
}
